import { render, staticRenderFns } from "./RegisterFence.vue?vue&type=template&id=2f8f637e&scoped=true&"
import script from "./RegisterFence.vue?vue&type=script&lang=js&"
export * from "./RegisterFence.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFence.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegisterFence.vue?vue&type=style&index=1&id=2f8f637e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f637e",
  null
  
)

export default component.exports